import React, { useState, useMemo, useCallback } from 'react';

// Поля для фильтрации (полный список загружаемых полей)
const FILTER_FIELDS = [
  // Основные CRM поля
  { id: 'id', name: 'ID', type: 'number' },
  { id: 'title', name: 'Название', type: 'string' },
  { id: 'opportunity', name: 'Сумма', type: 'number' },
  { id: 'createdTime', name: 'Дата создания', type: 'date' },
  { id: 'updatedTime', name: 'Дата обновления', type: 'date' },
  { id: 'assignedById', name: 'Ответственный', type: 'number' },
  { id: 'companyId', name: 'ID компании', type: 'number' },
  { id: 'contactId', name: 'ID контакта', type: 'number' },
  { id: 'createdBy', name: 'Создан пользователем', type: 'number' },
  
  { id: 'stageId', name: 'Стадия', type: 'select', options: [
    { value: 'DT1036_6:NEW', label: 'Новая заявка' },
    { value: 'DT1036_6:UC_58B1IG', label: 'Резка стекла' },
    { value: 'DT1036_6:UC_HD3BPN', label: 'Обработка стекла' },
    { value: 'DT1036_6:UC_PBEINX', label: 'На закалке' },
    { value: 'DT1036_6:UC_4FXLEO', label: 'Матировка' },
    { value: 'DT1036_6:UC_WE1KJE', label: 'Сборка лофта' },
    { value: 'DT1036_6:UC_SNLWF9', label: 'Упаковка' },
    { value: 'DT1036_6:UC_ZZP9IY', label: 'Комплектация' },
    { value: 'DT1036_6:SUCCESS', label: 'Выполнен' },
    { value: 'DT1036_7:NEW', label: 'Новая заявка' },
    { value: 'DT1036_7:UC_58B1IG', label: 'Резка стекла' },
    { value: 'DT1036_7:UC_HD3BPN', label: 'Обработка стекла' },
    { value: 'DT1036_7:UC_PBEINX', label: 'На закалке' },
    { value: 'DT1036_7:UC_4FXLEO', label: 'Матировка' },
    { value: 'DT1036_7:UC_WE1KJE', label: 'Сборка лофта' },
    { value: 'DT1036_7:UC_SNLWF9', label: 'Упаковка' },
    { value: 'DT1036_7:UC_ZZP9IY', label: 'Комплектация' },
    { value: 'DT1036_7:SUCCESS', label: 'Выполнен' }
  ]},
  
  // Пользовательские поля
  { id: 'ufCrm3_1746789101', name: 'Номер заказа', type: 'string' },
  { id: 'ufCrm3_1746789363', name: 'Товары', type: 'string' },
  { id: 'ufCrm3_1746789446', name: 'ID-B2C', type: 'string' },
  { id: 'ufCrm3_1746789468', name: 'ID-B2B', type: 'string' },
  { id: 'ufCrm3_1746789474', name: 'ID-Франчайзи', type: 'string' },
  { id: 'ufCrm3_1746789572', name: 'Триггер: Матовка', type: 'string' },
  { id: 'ufCrm3_1746789589', name: 'Триггер: упаковка', type: 'string' },
  { id: 'ufCrm3_1746789599', name: 'Триггер: Фурнитура', type: 'string' },
  { id: 'ufCrm3_1746789627', name: 'Триггер: Закалка', type: 'string' },
  { id: 'ufCrm3_1746789650', name: 'Триггер: LOFT / Зеркало', type: 'string' },
  { id: 'ufCrm3_1746789862', name: 'Поле 862', type: 'string' },
  { id: 'ufCrm3_1746789890', name: 'Поле 890', type: 'string' },
  { id: 'ufCrm3_1746789910', name: 'Поле 910', type: 'string' },
  { id: 'ufCrm3_1746790033', name: 'Поле 033', type: 'string' },
  { id: 'ufCrm3_1746790136', name: 'Поле 136', type: 'string' },
  { id: 'ufCrm3_1746790327', name: 'Поле 327', type: 'string' },
  
  // Ответственные
  { id: 'ufCrm3_1746790893', name: 'Ответственный за замер', type: 'string' },
  { id: 'ufCrm3_1746791181', name: 'Поле 181', type: 'string' },
  { id: 'ufCrm3_1747750785257', name: 'Поле 257', type: 'string' },
  { id: 'ufCrm3_1749212561933', name: 'Поле 933', type: 'string' },
  { id: 'ufCrm3_1749212579499', name: 'Ответственный за резку стекла', type: 'string' },
  { id: 'ufCrm3_1749212591302', name: 'Ответственный за матировку стекла', type: 'string' },
  { id: 'ufCrm3_1749212635898', name: 'Ответственный за сборку лофта и зеркала', type: 'string' },
  { id: 'ufCrm3_1749212685683', name: 'Поле 683', type: 'string' },
  { id: 'ufCrm3_1749212694990', name: 'Ответственный за упаковку', type: 'string' },
  { id: 'ufCrm3_1749212719306', name: 'Ответственный за закалку', type: 'string' },
  { id: 'ufCrm3_1749212970874', name: 'Поле 874', type: 'string' },
  { id: 'ufCrm3_1749212997464', name: 'Поле 464', type: 'string' },
  { id: 'ufCrm3_1749213049974', name: 'Поле 974', type: 'string' },
  { id: 'ufCrm3_1749213064008', name: 'Поле 008', type: 'string' },
  { id: 'ufCrm3_1749213221666', name: 'Поле 666', type: 'string' },
  { id: 'ufCrm3_1749213244986', name: 'Поле 986', type: 'string' },
  { id: 'ufCrm3_1749213340553', name: 'Поле 553', type: 'string' },
  { id: 'ufCrm3_1749213350972', name: 'Поле 972', type: 'string' },
  { id: 'ufCrm3_1749213376934', name: 'Поле 934', type: 'string' },
  { id: 'ufCrm3_1749475648149', name: 'Поле 149', type: 'string' },
  { id: 'ufCrm3_1749555592378', name: 'Поле 378', type: 'string' },
  { id: 'ufCrm3_1751274844238', name: 'Поле 238', type: 'string' },
  { id: 'ufCrm3_1751274861103', name: 'Поле 103', type: 'string' },
  { id: 'ufCrm3_1751275030885', name: 'Поле 885', type: 'string' },
  { id: 'ufCrm3_1751275041994', name: 'Поле 994', type: 'string' },
  { id: 'ufCrm3_1751275363654', name: 'Поле 654', type: 'string' },
  { id: 'ufCrm3_1751275374960', name: 'Поле 960', type: 'string' },
  { id: 'ufCrm3_1751279653655', name: 'Поле 655', type: 'string' },
  { id: 'ufCrm3_1751344784096', name: 'Поле 096', type: 'string' },
  { id: 'ufCrm3_1751344871698', name: 'Поле 698', type: 'string' },
  { id: 'ufCrm3_1751344928901', name: 'Поле 901', type: 'string' },
  { id: 'ufCrm3_1751370238766', name: 'Поле 766', type: 'string' },
  { id: 'ufCrm3_1751370309345', name: 'Поле 345', type: 'string' },
  { id: 'ufCrm3_1751370446708', name: 'Поле 708', type: 'string' },
];

// Статический список полей как fallback (с реальными названиями из Bitrix24)
const STATIC_FILTER_FIELDS = [
  { id: 'ufCrm3_1746789101', name: 'Номер заказа', type: 'string' },
  { id: 'ufCrm3_1746789363', name: 'Товары', type: 'string' },
  { id: 'ufCrm3_1746789446', name: 'ID-B2C', type: 'string' },
  { id: 'ufCrm3_1746789468', name: 'ID-B2B', type: 'string' },
  { id: 'ufCrm3_1746789474', name: 'ID-Франчайзи', type: 'string' },
  { id: 'ufCrm3_1746789572', name: 'Триггер: Матовка', type: 'string' },
  { id: 'ufCrm3_1746789589', name: 'Триггер: упаковка', type: 'string' },
  { id: 'ufCrm3_1746789599', name: 'Триггер: Фурнитура', type: 'string' },
  { id: 'ufCrm3_1746789627', name: 'Триггер: Закалка', type: 'string' },
  { id: 'ufCrm3_1746789650', name: 'Триггер: LOFT / Зеркало', type: 'string' },
  { id: 'ufCrm3_1746789862', name: 'Файл договора', type: 'file' },
  { id: 'ufCrm3_1746789890', name: 'Дизайн чертежа', type: 'file' },
  { id: 'ufCrm3_1746789910', name: 'Деталировка чертежа', type: 'file' },
  { id: 'ufCrm3_1746790033', name: 'Данные по замеру', type: 'file' },
  { id: 'ufCrm3_1746790136', name: 'Чертеж "загрузите старый чертеж до переделки"', type: 'file' },
  { id: 'ufCrm3_1746790327', name: 'Ответственный за чертеж:', type: 'user' },
  { id: 'ufCrm3_1746790893', name: 'Ответственный за замер:', type: 'string' },
  { id: 'ufCrm3_1746791181', name: 'Ответственный за фурнитуру:', type: 'user' },
  { id: 'ufCrm3_1747750785257', name: 'Триггер: Сырое стекло', type: 'string' },
  { id: 'ufCrm3_1749212561933', name: 'Ответственный за обработку и сверловку стекла', type: 'string' },
  { id: 'ufCrm3_1749212579499', name: 'Ответственный за резку стекла', type: 'string' },
  { id: 'ufCrm3_1749212591302', name: 'Ответственный за матировку стекла', type: 'string' },
  { id: 'ufCrm3_1749212635898', name: 'Ответственный за сборку лофта и зеркала', type: 'string' },
  { id: 'ufCrm3_1749212685683', name: 'Ответственный за сборку фурнитуры', type: 'string' },
  { id: 'ufCrm3_1749212694990', name: 'Ответственный за упаковку', type: 'string' },
  { id: 'ufCrm3_1749212719306', name: 'Ответственный за закалку', type: 'string' },
  { id: 'ufCrm3_1749212970874', name: 'Источник стекла душевой перегородки (Поставщик стекла)', type: 'string' },
  { id: 'ufCrm3_1749212997464', name: 'Источник стекла LOFT перегородки (Поставщик стекла)', type: 'string' },
  { id: 'ufCrm3_1749213049974', name: 'Ответственный за установку (ФИО, телефон)', type: 'string' },
  { id: 'ufCrm3_1749213064008', name: 'Ответственный за отправку', type: 'string' },
  { id: 'ufCrm3_1749213221666', name: 'Накладной документ от службы доставки', type: 'file' },
  { id: 'ufCrm3_1749213244986', name: 'Дата передачи заказа в службу доставки', type: 'date' },
  { id: 'ufCrm3_1749213340553', name: 'Данные по установке (фото и видео)', type: 'file' },
  { id: 'ufCrm3_1749213350972', name: 'Дата завершения установки', type: 'date' },
  { id: 'ufCrm3_1749213376934', name: 'Документ: АВР (акт выполненных работ)', type: 'file' },
  { id: 'ufCrm3_1749475648149', name: 'Данные по упаковке (фото и видео)', type: 'file' },
  { id: 'ufCrm3_1749555592378', name: 'Дата завершения упаковки', type: 'date' },
  { id: 'ufCrm3_1751274844238', name: 'Прозрачный 8 мм.', type: 'string' },
  { id: 'ufCrm3_1751274861103', name: 'Бронза 8 мм.', type: 'string' },
  { id: 'ufCrm3_1751275030885', name: 'Прозрачный 4 мм.', type: 'string' },
  { id: 'ufCrm3_1751275041994', name: 'Бронза 4 мм.', type: 'string' },
  { id: 'ufCrm3_1751275363654', name: 'Прозрачный 6 мм.', type: 'string' },
  { id: 'ufCrm3_1751275374960', name: 'Прозрачный 10 мм.', type: 'string' },
  { id: 'ufCrm3_1751279653655', name: 'Графит 8 мм.', type: 'string' },
  { id: 'ufCrm3_1751344784096', name: 'Резка запись для Лютер', type: 'string' },
  { id: 'ufCrm3_1751344871698', name: 'Итог Резка', type: 'string' },
  { id: 'ufCrm3_1751344928901', name: 'Резка коментарии', type: 'string' },
  { id: 'ufCrm3_1751370238766', name: 'Сверловка запись для Лютер', type: 'string' },
  { id: 'ufCrm3_1751370309345', name: 'Сверловка коментарии', type: 'string' },
  { id: 'ufCrm3_1751370446708', name: 'Серловка итог', type: 'string' },
  
  // Дополнительные поля из списка
  { id: 'ufCrm3_1751456530577', name: 'Сверловка коментарии', type: 'string' },
  { id: 'ufCrm3_1751521756206', name: 'Закалка запись для Лютер', type: 'string' },
  { id: 'ufCrm3_1751521814271', name: 'Отчет для закалки', type: 'string' },
  { id: 'ufCrm3_1751521846111', name: 'Коментарий закалка', type: 'string' },
  { id: 'ufCrm3_1752035088903', name: 'Матовка Запись для Лютер', type: 'string' },
  { id: 'ufCrm3_1752035158464', name: 'Матировка отчет', type: 'string' },
  { id: 'ufCrm3_1752035904757', name: 'Коментариий Матовка', type: 'string' },
  { id: 'ufCrm3_1752122668020', name: 'Отчет о переделке', type: 'string' },
  { id: 'ufCrm3_1752145786785', name: 'Ответсвенный за сборку лофта/зеркало', type: 'string' },
  { id: 'ufCrm3_1752145842832', name: 'Ответственный за фурнитуру', type: 'string' },
  { id: 'ufCrm3_1752165266', name: 'Графит 4 мм.', type: 'string' },
  { id: 'ufCrm3_1752818210443', name: 'Закалка прием запись JSON', type: 'string' },
  { id: 'ufCrm3_1752818233225', name: 'Отчет о приеме закалки', type: 'string' },
  { id: 'ufCrm3_1752818259434', name: 'Коментарий прием закалка', type: 'string' },
  { id: 'ufCrm3_1753076476775', name: 'Адрес заказа:', type: 'string' },
  { id: 'ufCrm3_1753263371950', name: 'Записаны ли деталировки стекол для производства?', type: 'select' },
  { id: 'ufCrm3_1753795707997', name: 'Файл фурнитуры', type: 'file' },
  { id: 'ufCrm3_1753799333731', name: 'Триггер: Переделка', type: 'string' },
  { id: 'ufCrm3_1753799343825', name: 'Триггер: Бой на закалке', type: 'string' },
  { id: 'ufCrm3_1753862276063', name: 'Статус фурнитуры', type: 'string' },
  { id: 'ufCrm3_1754027253985', name: 'Графит 6 мм.', type: 'string' },
  { id: 'ufCrm3_1754027309932', name: 'Бронза 6 мм.', type: 'string' },
  { id: 'ufCrm3_1754027324300', name: 'Бронза 10 мм.', type: 'string' },
  { id: 'ufCrm3_1754027335383', name: 'Графит 10 мм.', type: 'string' },
  { id: 'ufCrm3_1754046893462', name: 'Лофт файл и фидео', type: 'file' },
  { id: 'ufCrm3_1755579125099', name: 'Комментарий для чертежника:', type: 'string' },
  { id: 'ufCrm3_1755579396141', name: 'Комментарий по доработке чертежа:', type: 'string' },
  { id: 'ufCrm3_1757005830', name: 'Выдача фото и видео', type: 'file' },
  { id: 'ufCrm3_1757404689894', name: 'Таймлайн цеха', type: 'string' },
];

// Операторы для разных типов полей
const OPERATORS = {
  string: [
    { value: 'contains', label: 'содержит' },
    { value: 'not_contains', label: 'не содержит' },
    { value: 'equals', label: 'равно' },
    { value: 'not_equals', label: 'не равно' },
    { value: 'empty', label: 'пусто' },
    { value: 'not_empty', label: 'не пусто' }
  ],
  number: [
    { value: 'equals', label: 'равно' },
    { value: 'not_equals', label: 'не равно' },
    { value: 'greater', label: 'больше' },
    { value: 'less', label: 'меньше' },
    { value: 'empty', label: 'пусто' },
    { value: 'not_empty', label: 'не пусто' }
  ],
  date: [
    { value: 'equals', label: 'равно' },
    { value: 'not_equals', label: 'не равно' },
    { value: 'greater', label: 'после' },
    { value: 'less', label: 'до' },
    { value: 'empty', label: 'пусто' },
    { value: 'not_empty', label: 'не пусто' }
  ],
  select: [
    { value: 'equals', label: 'равно' },
    { value: 'not_equals', label: 'не равно' }
  ],
  file: [
    { value: 'empty', label: 'пусто' },
    { value: 'not_empty', label: 'не пусто' }
  ],
  user: [
    { value: 'equals', label: 'равно' },
    { value: 'not_equals', label: 'не равно' },
    { value: 'empty', label: 'пусто' },
    { value: 'not_empty', label: 'не пусто' }
  ]
};

const SimpleSearchFilter = ({ data, fieldMetadata = {}, onFilteredData, onSelectedFields }) => {
  const [filterRows, setFilterRows] = useState([
    { id: Date.now(), field: '', operator: '', value: '' }
  ]);

  // Создаем динамический список полей на основе метаданных
  const dynamicFilterFields = useMemo(() => {
    const fields = [];
    
    // Добавляем стандартные поля
    fields.push(
      { id: 'id', name: 'ID', type: 'number' },
      { id: 'title', name: 'Название', type: 'string' },
      { id: 'opportunity', name: 'Сумма', type: 'number' },
      { id: 'createdTime', name: 'Дата создания', type: 'date' },
      { id: 'updatedTime', name: 'Дата обновления', type: 'date' },
      { id: 'assignedById', name: 'Ответственный', type: 'number' },
      { id: 'companyId', name: 'ID компании', type: 'number' },
      { id: 'contactId', name: 'ID контакта', type: 'number' },
      { id: 'createdBy', name: 'Создан пользователем', type: 'number' },
      { 
        id: 'stageId', 
        name: 'Стадия', 
        type: 'select', 
        options: [
          { value: 'DT1036_6:NEW', label: 'Новая заявка (кат.6)' },
          { value: 'DT1036_6:UC_58B1IG', label: 'Резка стекла (кат.6)' },
          { value: 'DT1036_6:UC_HD3BPN', label: 'Обработка стекла (кат.6)' },
          { value: 'DT1036_6:UC_PBEINX', label: 'На закалке (кат.6)' },
          { value: 'DT1036_6:UC_4FXLEO', label: 'Матировка (кат.6)' },
          { value: 'DT1036_6:UC_WE1KJE', label: 'Сборка лофта (кат.6)' },
          { value: 'DT1036_6:UC_SNLWF9', label: 'Упаковка (кат.6)' },
          { value: 'DT1036_6:UC_ZZP9IY', label: 'Комплектация (кат.6)' },
          { value: 'DT1036_6:SUCCESS', label: 'Выполнен (кат.6)' },
          { value: 'DT1036_7:NEW', label: 'Новая заявка (кат.7)' },
          { value: 'DT1036_7:UC_58B1IG', label: 'Резка стекла (кат.7)' },
          { value: 'DT1036_7:UC_HD3BPN', label: 'Обработка стекла (кат.7)' },
          { value: 'DT1036_7:UC_PBEINX', label: 'На закалке (кат.7)' },
          { value: 'DT1036_7:UC_4FXLEO', label: 'Матировка (кат.7)' },
          { value: 'DT1036_7:UC_WE1KJE', label: 'Сборка лофта (кат.7)' },
          { value: 'DT1036_7:UC_SNLWF9', label: 'Упаковка (кат.7)' },
          { value: 'DT1036_7:UC_ZZP9IY', label: 'Комплектация (кат.7)' },
          { value: 'DT1036_7:SUCCESS', label: 'Выполнен (кат.7)' }
        ]
      }
    );

    // Всегда добавляем статические пользовательские поля
    console.log('📊 Добавляем статические поля. Состояние метаданных:', {
      hasMetadata: Object.keys(fieldMetadata).length > 0,
      fieldCount: Object.keys(fieldMetadata).length,
      staticFieldsCount: STATIC_FILTER_FIELDS.length
    });
    
    // Добавляем статические поля
    fields.push(...STATIC_FILTER_FIELDS);
    
    // Если есть метаданные, обновляем названия или добавляем новые поля
    if (Object.keys(fieldMetadata).length > 0) {
      let updatedFieldsCount = 0;
      let newFieldsCount = 0;
      
      Object.keys(fieldMetadata).forEach(fieldId => {
        const field = fieldMetadata[fieldId];
        if (field && fieldId.startsWith('ufCrm')) {
          // Проверяем, есть ли уже такое поле в статическом списке
          const existingFieldIndex = fields.findIndex(f => f.id === fieldId);
          
          let fieldType = 'string';
          
          // Определяем тип поля на основе метаданных Bitrix
          if (field.type === 'integer' || field.type === 'double') {
            fieldType = 'number';
          } else if (field.type === 'date' || field.type === 'datetime') {
            fieldType = 'date';
          } else if (field.listItems && Object.keys(field.listItems).length > 0) {
            fieldType = 'select';
          } else if (field.type === 'file') {
            fieldType = 'file';
          } else if (field.type === 'employee') {
            fieldType = 'user';
          }

          const fieldConfig = {
            id: fieldId,
            name: field.title || field.formLabel || fieldId,
            type: fieldType
          };

          // Добавляем опции для select полей
          if (fieldType === 'select' && field.listItems) {
            fieldConfig.options = Object.entries(field.listItems).map(([value, label]) => ({
              value,
              label
            }));
          }

          if (existingFieldIndex >= 0) {
            // Обновляем существующее поле с реальными данными
            fields[existingFieldIndex] = fieldConfig;
            updatedFieldsCount++;
          } else {
            // Добавляем новое поле
            fields.push(fieldConfig);
            newFieldsCount++;
          }
        }
      });
      
      console.log('✅ Обработка метаданных завершена:', {
        updatedFields: updatedFieldsCount,
        newFields: newFieldsCount
      });
    } else {
      console.log('🔄 Метаданные еще не загружены, используем только статические поля');
    }

    console.log('📋 Итоговый список полей:', {
      totalFields: fields.length,
      standardFields: 9,
      customFields: fields.length - 9
    });
    
    return fields;
  }, [fieldMetadata]);

  // Получить поле по ID
  const getFieldById = useCallback((fieldId) => {
    return dynamicFilterFields.find(f => f.id === fieldId);
  }, [dynamicFilterFields]);

  // Получить операторы для типа поля
  const getOperatorsForField = useCallback((fieldId) => {
    const field = getFieldById(fieldId);
    return field ? OPERATORS[field.type] || [] : [];
  }, [getFieldById]);

  // Проверить нужно ли значение для оператора
  const operatorNeedsValue = useCallback((operator) => {
    return !['empty', 'not_empty'].includes(operator);
  }, []);

  // Обновить строку фильтра
  const updateFilterRow = useCallback((id, updates) => {
    setFilterRows(prev => prev.map(row => 
      row.id === id ? { ...row, ...updates } : row
    ));
  }, []);

  // Добавить новую строку фильтра
  const addFilterRow = useCallback(() => {
    setFilterRows(prev => [...prev, {
      id: Date.now(),
      field: '',
      operator: '',
      value: ''
    }]);
  }, []);

  // Удалить строку фильтра
  const removeFilterRow = useCallback((id) => {
    setFilterRows(prev => prev.filter(row => row.id !== id));
  }, []);

  // Применить конкретный фильтр к элементу
  const applyFilterCondition = useCallback((item, condition) => {
    const { field, operator, value } = condition;
    const itemValue = item[field];
    const fieldType = getFieldById(field)?.type;

    // Обработка дат
    if (fieldType === 'date' && value && itemValue) {
      const itemDate = new Date(itemValue);
      const compareDate = new Date(value);
      
      switch (operator) {
        case 'equals':
          return itemDate.toDateString() === compareDate.toDateString();
        case 'not_equals':
          return itemDate.toDateString() !== compareDate.toDateString();
        case 'greater':
          return itemDate > compareDate;
        case 'less':
          return itemDate < compareDate;
        case 'empty':
          return !itemValue || String(itemValue).trim() === '';
        case 'not_empty':
          return itemValue && String(itemValue).trim() !== '';
        default:
          return true;
      }
    }

    // Обработка чисел
    if (fieldType === 'number' && operator === 'greater' || operator === 'less') {
      switch (operator) {
        case 'greater':
          return Number(itemValue) > Number(value);
        case 'less':
          return Number(itemValue) < Number(value);
        default:
          break;
      }
    }

    // Стандартная обработка строк и остальных типов
    switch (operator) {
      case 'contains':
        return itemValue && String(itemValue).toLowerCase().includes(String(value).toLowerCase());
      
      case 'not_contains':
        return !itemValue || !String(itemValue).toLowerCase().includes(String(value).toLowerCase());
      
      case 'equals':
        return String(itemValue) === String(value);
      
      case 'not_equals':
        return String(itemValue) !== String(value);
      
      case 'greater':
        return Number(itemValue) > Number(value);
      
      case 'less':
        return Number(itemValue) < Number(value);
      
      case 'empty':
        return !itemValue || String(itemValue).trim() === '';
      
      case 'not_empty':
        return itemValue && String(itemValue).trim() !== '';
      
      default:
        return true;
    }
  }, [getFieldById]);

  // Применение всех фильтров
  const filteredData = useMemo(() => {
    let result = data;

    // Фильтры конструктора (все условия через AND)
    const validFilters = filterRows.filter(row => 
      row.field && row.operator && (operatorNeedsValue(row.operator) ? row.value : true)
    );

    if (validFilters.length > 0) {
      result = result.filter(item => 
        validFilters.every(condition => applyFilterCondition(item, condition))
      );
    }

    return result;
  }, [data, filterRows, operatorNeedsValue, applyFilterCondition]);

  // Получение списка выбранных полей для отображения
  const selectedFields = useMemo(() => {
    const defaultFields = ['ufCrm3_1746789101', 'createdTime']; // Номер заказа и дата создания по умолчанию
    const filterFields = filterRows
      .filter(row => row.field)
      .map(row => row.field);
    
    // Объединяем и убираем дубликаты
    const allFields = [...new Set([...defaultFields, ...filterFields])];
    return allFields;
  }, [filterRows]);

  // Обновляем родительский компонент при изменении фильтров
  React.useEffect(() => {
    onFilteredData(filteredData);
  }, [filteredData, onFilteredData]);

  // Обновляем родительский компонент при изменении выбранных полей
  React.useEffect(() => {
    if (onSelectedFields) {
      onSelectedFields(selectedFields);
    }
  }, [selectedFields, onSelectedFields]);

  // Сбросить все фильтры
  const resetAllFilters = useCallback(() => {
    setFilterRows([{ id: Date.now(), field: '', operator: '', value: '' }]);
  }, []);

  return (
    <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
      <div className="flex flex-col space-y-4">
        
        {/* Конструктор фильтров */}
        <div>
          <div className="flex items-center justify-between mb-3">
            <label className="block text-sm font-medium text-gray-700">
              Фильтры
            </label>
            <button
              onClick={addFilterRow}
              className="px-3 py-1 text-sm bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
            >
              + Добавить условие
            </button>
          </div>

          <div className="space-y-3">
            {filterRows.map((row, index) => {
              const field = getFieldById(row.field);
              const operators = getOperatorsForField(row.field);
              const needsValue = operatorNeedsValue(row.operator);

              return (
                <div key={row.id} className="flex items-center gap-3 p-3 bg-gray-50 rounded-md">
                  {/* Поле */}
                  <select
                    value={row.field}
                    onChange={(e) => updateFilterRow(row.id, { 
                      field: e.target.value, 
                      operator: '', 
                      value: '' 
                    })}
                    className="flex-1 px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">Выберите поле</option>
                    {dynamicFilterFields.map(field => (
                      <option key={field.id} value={field.id}>
                        {field.name}
                      </option>
                    ))}
                  </select>

                  {/* Оператор */}
                  <select
                    value={row.operator}
                    onChange={(e) => updateFilterRow(row.id, { 
                      operator: e.target.value, 
                      value: '' 
                    })}
                    disabled={!row.field}
                    className="flex-1 px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100"
                  >
                    <option value="">Оператор</option>
                    {operators.map(op => (
                      <option key={op.value} value={op.value}>
                        {op.label}
                      </option>
                    ))}
                  </select>

                  {/* Значение */}
                  {needsValue && (
                    <div className="flex-1">
                      {field?.type === 'select' ? (
                        <select
                          value={row.value}
                          onChange={(e) => updateFilterRow(row.id, { value: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        >
                          <option value="">Выберите значение</option>
                          {field.options?.map(option => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <input
                          type={field?.type === 'number' ? 'number' : field?.type === 'date' ? 'date' : 'text'}
                          value={row.value}
                          onChange={(e) => updateFilterRow(row.id, { value: e.target.value })}
                          placeholder={field?.type === 'date' ? 'Выберите дату' : 'Введите значение'}
                          className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                      )}
                    </div>
                  )}

                  {/* Кнопка удаления */}
                  {filterRows.length > 1 && (
                    <button
                      onClick={() => removeFilterRow(row.id)}
                      className="p-2 text-red-600 hover:text-red-800 hover:bg-red-50 rounded"
                      title="Удалить условие"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Статистика */}
        <div className="flex items-center justify-between pt-4 border-t border-gray-200">
          <div className="text-sm text-gray-600">
            Показано: <span className="font-semibold text-gray-900">{filteredData.length}</span> из{' '}
            <span className="font-semibold text-gray-900">{data.length}</span> записей
          </div>
          
          <div className="flex space-x-2">
            <button
              onClick={resetAllFilters}
              className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800 border border-gray-300 rounded-md hover:bg-gray-50"
            >
              Сбросить все фильтры
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleSearchFilter;